import { Grid, Tooltip as MuiTooltip, useMediaQuery, useTheme } from "@mui/material";
import {
    Bar,
    BarChart,
    Cell,
    ResponsiveContainer,
    XAxis,
    YAxis,
    Tooltip
} from "recharts";
import { TareaDialog } from "../../../global/proyectos/tareas/TareaDialog";
import { useState } from "react";
import { getTodasTareasInfoUnica } from "../../../services/apis";

export const BarrasHorasInvertidasHorizontalesDia = ({ data }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [open, setOpen] = useState(false);
    const [tareaInfo, setTareaInfo] = useState({});
    const [opciones, setOpciones] = useState([]);
    const [backgroundCard, setBackgroundCard] = useState("");
    const [textColor, setTextColor] = useState("");
    const [horasTotales, setHorasTotales] = useState(0);

    const convertirHoras = (horas) => {
        const h = Math.floor(horas);
        const m = Math.round((horas - h) * 60);
        return `${h}h${m > 0 ? ` ${m}min` : ''}`;
    };

    const redondearAHorasCuarto = (valor) => {
        return Math.round(valor * 4) / 4;
    };
    const extraerNumero = (cadena) => {
        const match = cadena.match(/^\d+/);
        return match ? parseInt(match[0], 10) : null;
    };

    const handleEvent = (e) => {
        if (e && e.value) {
            const numero = extraerNumero(e.value);
            if (numero !== null) {
                setTareaInfo((prev) => ({
                    ...prev,
                    id: numero
                }));
                buscarInfoTarea(numero);
            }
        }
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const { nombre, horas } = payload[0].payload;
            console.log(payload);
            
            return (
                <div
                    style={{
                        backgroundColor: 'white',
                        padding: '8px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        fontSize: '12px',
                        maxWidth: '200px',
                        wordBreak: 'break-word'
                    }}
                >
                    <strong>{nombre}</strong><br />
                    Horas: {convertirHoras(horas)} <br />
                </div>
            );
        }
        return null;
    };

    const tareasConColor = data.map(t => {
        const horasRedondeadas = redondearAHorasCuarto(t.horas);
        return {
            ...t,
            horas: horasRedondeadas,
            color: `hsl(${Math.random() * 360}, 70%, 60%)`
        };
    });


    const buscarInfoTarea = async (id) => {
        try {
            console.log(id);

            if (!id) return;
            const response = await getTodasTareasInfoUnica(id);
            if (response && response.data) {
                console.log(response.data.tareas[0]);
                setTareaInfo(response.data.tareas[0]);
                setOpciones(response.data.opcionesTareas);
                setOpen(true);

            }

        }
        catch (error) {
            console.error("Error al buscar información de la tarea:", error);
        }
    }
    return (
        <div
            style={{
                width: '100%',
                overflowX: 'auto',
                maxWidth: '100vw',
                minHeight: 120, // mínimo visible en caso de 1 sola barra
                height: tareasConColor.length * 50,
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={tareasConColor}
                    layout="vertical"
                    margin={{ top: 10, right: 10, left: 0, bottom: 10 }} // <-- ajustado
                >
                    <XAxis
                        type="number"
                        domain={[0, 'dataMax + 0.5']}
                        tickFormatter={(value) => {
                            const h = Math.floor(value);
                            const m = Math.round((value - h) * 60);
                            return `${h}h${m > 0 ? ` ${m}m` : ''}`;
                        }}
                        tick={{ fontSize: 11, angle: -30, dy: 10 }} // <-- rotación y espacio
                    />
                    <YAxis
                        type="category"
                        dataKey="nombre"
                        tick={{ fontSize: 12 }}
                        style={{ marginTop: '3em', marginBottom: '3em'}}
                        width={window.innerWidth < 500 ? 150 : 180}
                        onClick={(e) => {
                            if (e && e.value) {
                                buscarInfoTarea(extraerNumero(e.value));
                            }
                        }}
                    />

                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="horas" barSize={24}>
                        {tareasConColor.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Bar>
                </BarChart>

            </ResponsiveContainer>
            {open && (


                <Grid container xs={12} justifyContent={'space-between'}>
                    <TareaDialog open={open} setOpen={setOpen} tareaInfo={tareaInfo} setTareaInfo={setTareaInfo} opciones={opciones} handleEvent={handleEvent} backgroundCard={backgroundCard} textColor={textColor} setHorasTotales={setHorasTotales} />
                </Grid >
            )}
        </div>
    );
};
